#import "../fragments/contact-attachments-fragment.graphql"

query GetAttachmentsForContact($contactId: ID!) {
    contact(id: $contactId) {
        ...ContactAttachmentsFragment
    }
}
